import React from "react";
import { Box, Typography } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import FactCheckIcon from "@mui/icons-material/FactCheck";

import { BADGE_COLORS } from "../../../../components/ui/badgeColors";
import { INVENTARIO_ESTADO, ETIQUETAS_ESTADO } from "../../constants";

const ICONO_ESTADO = {
    [INVENTARIO_ESTADO.PENDIENTE]: HourglassEmptyIcon,
    [INVENTARIO_ESTADO.EN_CURSO]: AutorenewIcon,
    [INVENTARIO_ESTADO.COMPLETADO]: CheckCircleIcon,
    [INVENTARIO_ESTADO.REVISADO]: DoneAllIcon,
};

// Total no es un estado: INDIGO, porque BLUE ya es "Revisado" (ver badges en CLAUDE.md)
const FICHAS = [
    ...Object.values(INVENTARIO_ESTADO).map((estado) => ({
        estado,
        label: ETIQUETAS_ESTADO[estado].label,
        color: ETIQUETAS_ESTADO[estado].color,
        Icono: ICONO_ESTADO[estado],
    })),
    { estado: "", label: "Total", color: BADGE_COLORS.INDIGO, Icono: FactCheckIcon },
];

/**
 * Fichas de recuento por estado (mismo diseño que el panel de peticiones).
 * Pulsar una filtra por ese estado; pulsarla otra vez, o Total, quita el filtro
 */
const EstadisticasInventarios = ({ estadisticas, estadoActivo, onSeleccionar }) => (
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(5, 1fr)" }, gap: 1.5 }}>
        {FICHAS.map(({ estado, label, color, Icono }) => {
            const activa = estado ? estadoActivo === estado : !estadoActivo;
            const valor = estado ? estadisticas.porEstado?.[estado] ?? 0 : estadisticas.total ?? 0;

            return (
                <Box
                    key={label}
                    role="button"
                    aria-pressed={activa}
                    onClick={() => onSeleccionar(estado && estadoActivo === estado ? "" : estado)}
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "flex-start", sm: "center" },
                        gap: { xs: 0.5, sm: 0.75 },
                        px: { xs: 1.5, sm: 2 },
                        py: { xs: 1.5, sm: 1.25 },
                        borderRadius: 1,
                        backgroundColor: color.bg,
                        cursor: "pointer",
                        transition: "all 0.2s",
                        border: activa ? `2px solid ${color.border}` : "2px solid transparent",
                        "&:hover": { transform: "translateY(-2px)", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
                    }}
                >
                    <Icono sx={{ fontSize: { xs: 24, sm: 22 }, color: color.text }} />
                    <Box>
                        <Typography sx={{ fontSize: { xs: 12, sm: 14 }, fontWeight: 600, color: "#495057", lineHeight: 1.2 }}>
                            {label}
                        </Typography>
                        <Typography sx={{ fontSize: { xs: 18, sm: 16 }, fontWeight: 700, color: color.text, lineHeight: 1 }}>
                            {valor}
                        </Typography>
                    </Box>
                </Box>
            );
        })}
    </Box>
);

export default EstadisticasInventarios;
